import * as React from 'react';
import styled from 'styled-components';
import { ThemeInterface } from '../theme/ThemeInterface';
import { themeGet } from 'styled-system';
import { theme } from '../theme';

type Props = {
  items: Array<{ label: string; value: string }>;
  onChange: (e: React.ChangeEvent<any>) => void;
};

const InputWrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding: 30px;
  position: relative;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 10px;
  box-sizing: border-box;
  justify-content: center;
  border: 1px solid ${themeGet('colors.paleGrey', '#eee')};
  & input[type='radio'] {
    position: absolute;
    visibility: hidden;
  }
  & input[type='radio']:checked ~ .check {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
    background: ${themeGet('colors.putty', '#eee')};
  }
  & input[type='radio']:checked ~ label {
    color: ${themeGet('colors.putty', '#eee')};
    border: 1px solid ${themeGet('colors.putty', '#eee')};
  }
  & .check {
    z-index: ${theme.zIndex[4]};
    left: 20px;
    width: 15px;
    height: 15px;
    display: block;
    position: absolute;
    border-radius: 4px;
    transition: border 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 2px solid ${themeGet('colors.transparentBlack', '#eee')};
  }
  &:hover label {
    color: ${themeGet('colors.putty', '#eee')};
  }
  &:hover .check {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
  }
`;

const RadioLabel = styled.label`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${theme.zIndex[5]};
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  position: absolute;
  align-items: center;
  font-weight: normal;
  justify-content: center;
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[2]};
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  overflow-y: auto;
  max-height: 500px;
  flex-direction: column;
`;

const RadioButtons: React.FunctionComponent<Props> = props => {
  const { items, onChange } = props;
  return (
    <Wrapper>
      {items.map(item => (
        <InputWrap key={item.value}>
          <input type="radio" id={item.value} name="selector" value={item.value} onChange={onChange} />
          <RadioLabel htmlFor={item.value}>{item.label}</RadioLabel>
          <div className="check" />
        </InputWrap>
      ))}
    </Wrapper>
  );
};

export default RadioButtons;



// WEBPACK FOOTER //
// ./src/components/RadioButtons.tsx